// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Navbar_navigation__2s0Wn"};